import { loadPreferences, myPreferences, savePreferences } from '@/appLogic/view/preferences';
import { TableType } from '@/coreDomainsModule/table';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { simpleCopy } from '@/utils/deepCopy';

/**
 * ヘッダーの表示/非表示の情報をDBに保存する
 */
export class SaveTableHeaderHidePreferenceUseCase {
  /**
   * ヘッダーの表示/非表示の情報をDBに保存する
   * @param tableType - テーブルの種類
   * @param header - 変更対象のヘッダー
   * @param isHide - 非表示にするかどうか
   * @returns 失敗した時はエラーを返す
   */
  public async Execute(tableType: TableType, header: string, isHide: boolean): Promise<INetworkResult<void, Error>> {
    try {
      // 最新のPreferencesを取得
      await loadPreferences();
      if (!myPreferences || !Object.keys(myPreferences).includes(tableType)) {
        return {
          status: {
            type: 'error',
            error: Error('保存に失敗しました'),
          },
        };
      }
      const preference = simpleCopy(myPreferences[tableType]);

      if (isHide) {
        preference.hideHeaderList.push(header);
      } else {
        preference.hideHeaderList = preference.hideHeaderList.filter((value) => value !== header);
      }

      myPreferences[tableType] = preference;
      await savePreferences();
      return {
        status: {
          type: 'success',
          data: undefined,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('取得に失敗しました'),
        },
      };
    }
  }
}
